const Quotazioni = () => {
    return <div></div>
}

export default Quotazioni
